import type { SortingState } from "@tanstack/react-table";
import { capitalize, upperFirst } from "es-toolkit";

import type {
  DaoCoinStatsOrderBy,
  TokenBalancesOrderBy,
  TokenBalanceSummariesOrderBy,
  TradingRecentTradesOrderBy,
  TradingTopTradersByTokenByVolumesOrderBy,
  UserDaoCoinStatsOrderBy,
} from "@/graphql/codegen/graphql";

export const transformTradeOrderByKey = (key: string) => {
  if (/^(VolumeUsd|PriceUsdPctChange)/.test(key)) {
    return key.replace(/(VolumeUsdPast|PriceUsdPctChange)(\d+[HD])_/, "$1_$2");
  }
  return key.replaceAll("_", "");
};

export const getOrderByKey = <
  T extends
    | typeof DaoCoinStatsOrderBy
    | typeof UserDaoCoinStatsOrderBy
    | typeof TokenBalancesOrderBy
    | typeof TokenBalanceSummariesOrderBy
    | typeof TradingRecentTradesOrderBy
    | typeof TradingTopTradersByTokenByVolumesOrderBy,
>(
  columnSorting: SortingState,
  orderByEnum: T,
  defaultValue: T[keyof T],
): T[keyof T] => {
  if (!columnSorting.length) {
    return defaultValue;
  }

  const getOrderByKey = transformTradeOrderByKey(
    `${upperFirst(
      columnSorting[0].id,
    )}_${capitalize(columnSorting[0]?.desc ? "Desc" : "Asc")}`,
  );

  return orderByEnum[getOrderByKey as keyof T] || defaultValue;
};
